

require('./dataCaptureSelector');

/** dash.topControls Module initialization */
angular.module('dash.topControls', [
  'dash.topControls.dataCaptureSelector'
])

//Flux components
  .factory('TopControlsActions', require('./TopControlsActions'))
  .factory('TopControlsStore', require('./TopControlsStore'))

  .controller('TopControlsController', require('./TopControlsController'))
  .directive('topControls', require('./TopControlstDirective'))

  .run(['TopControlsStore', function (TopControlsStore) {
    TopControlsStore.init();
  }]);



// WEBPACK FOOTER //
// ./src/app/dash/topControls/index.js